{{
  badge.content.includes("badge:")
    ? badge.content.split("badge:")[1]
    : badge.content
}}
